import React from 'react'

function Intro() {
  return (
    <>
      <div className='w-full bg-gray-100 py-8 px-4'>
        <div className='max-w-[1240px] mx-auto text-center'>
          <h1 className='font-bold md:text-4xl sm:text-3xl text-2xl py-3'>Вспомним всё...</h1>
          <p className='text-left mx-auto py-1'> Дорогие друзья! Все, кто помнит и любит сайт kayrakkum.com, или пока ещё не забыл.
            Так получилось, что реальность оказывается порой сильнее наших самых сильных привязанностей. За прошедшие 20 лет интернет вырос из доступного едицам развлечения
            до привычного, обыденного и порой даже незаменимого для многих атрибута жизни. Современной жизни.</p>
          <p className='text-left mx-auto py-1'>Когда много лет назад мы основали сайт kayrakkum.com, это была как раз первая фаза, и мы хотели сделать что-то
            приятное и нужное всем нам и вам. Что из этого получилось - судить вам. Мы просто хотели, чтобы наше виртуальное общение
            было живым и здоровым, тёплым и домашним. Мы честно старались.</p>
          <p className='text-left mx-auto py-1'>Шли годы, появлялись новые пожелания, требования, и возможности. Необходимо было идти в ногу со временем,
            и мы старались не отставать. Мы несколько раз обновляли сайт, всего за все эти годы было четыре поколения сайта.
            Нужно заметить, что всё это делалось и поддерживалось нами на чистом энтузиазме, только из одного желания - сайт должен
            жить и приносить радость. </p>
          <p className='text-left mx-auto py-2'>Конечно, мы не смогли выдержать конкуренции с социальными сетями, да наверное это было
            невозможно. А может быть и не нужно. Как говорится, мавр сделал своё дело, мавр может уходить. Как вы знаете, последние несколько лет наш старый добрый
            Кайраккум был недоступен. И вот по прошествии стольких лет мы наконец пришли к мнению, что нам нужно всем сообща решить его судьбу.
            Должны ли мы его окончательно похоронить, или...</p>
          <p className='text-left mx-auto py-2'>У нас самих на высшую меру так и не поднялась рука. Поэтому мы решили спросить всех вас,
            и принять решение. Сейчас вы можете найти здесь весь наш старый фотоархив, некоторые уникальные видеоматериалы.
            Однако тут нет пока больше никакого функционала, из того, к чему вы привыкли уже на одноклассниках и Ко.</p>
          <p className='text-left mx-auto py-2'>Итак, выносим на референдум следующие вопросы:</p>
        </div>
      </div>
      <div className='w-full bg-w py-8 px-4 max-w-[1240px] mx-auto'>
        <div className='text-left'>
          <ul className='list-decimal ml-4'>
            <li>Необходимо ли сохранить сайт kayrakkum.com?</li>
            <li>Если да, что почему?</li>
            <li>Какую функциональность вы хотели бы иметь на сайте kayrakkum.com?
              <ul className='list-none'>
                <li>а. Фотогалерею со всей функциональностью</li>
                <li>б. Форум</li>
                <li>в. Личные сообщения</li>
                <li>г. Свой вариант</li>

              </ul>
            </li>
            
          </ul>
          <p className='text-left mx-auto py-2'>Ответить на вопросы можно здесь, на странице <a className="font-bold" href="/contact">контактной формы</a>, или по адресу <a className="font-bold" href="mailto:alex@alexander-naumov.com">alex@alexander-naumov.com</a></p>
          <p className='text-left mx-auto py-2'>Или любым другим удобным для вас способом - в комментариях или в личных сообщениях в одноклассниках, либо в других соц.сетях. Пишите мне - Александру Наумову либо Евгению Борочину</p>
          <p className='text-left mx-auto py-2'>Решение будет зависить от вашей активности и вашего мнения. </p>
        
        </div>
      </div>
    </>
  )
}

export default Intro